var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 35,
    viewBox: "0 0 29 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33043 30.8764C5.49233 32.7537 7.00334 34.1917 8.81501 34.1997H20.8569C22.6762 34.1917 24.1796 32.7458 24.3414 30.8764L26.2071 9.87405H3.45708L5.32272 30.8764H5.33043ZM17.1641 15.9135C17.1641 15.2425 17.6884 14.7072 18.3282 14.7072C18.9681 14.7072 19.4923 15.2505 19.4923 15.9135V26.9459C19.4923 27.617 18.9681 28.1522 18.3282 28.1522C17.6884 28.1522 17.1641 27.609 17.1641 26.9459V15.9135ZM10.1718 15.9135C10.1718 15.2425 10.6961 14.7072 11.3359 14.7072C11.9758 14.7072 12.5 15.2505 12.5 15.9135V26.9459C12.5 27.617 11.9758 28.1522 11.3359 28.1522C10.6961 28.1522 10.1718 27.609 10.1718 26.9459V15.9135ZM28.8359 6.24717C28.8359 6.91023 28.3117 7.45347 27.6718 7.45347H2.00003C1.35246 7.45347 0.835938 6.91023 0.835938 6.24717C0.835938 5.58411 1.36017 5.04087 2.00003 5.04087H7.11127L8.47581 2.21286C9.06942 0.974613 10.2875 0.199707 11.6135 0.199707H18.0507C19.3767 0.199707 20.5947 0.974613 21.1884 2.20488L22.5529 5.03288H27.6641C28.304 5.03288 28.8282 5.57612 28.8282 6.23918L28.8359 6.24717Z",
    className: "color5Fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.61d580ab7665d93370ae2d17866f2047.svg";
export { ForwardRef as ReactComponent };